const DB_KEY = 'STATSIG_LOCAL_DATA'
const DB_CACHE_TTL_MS = 60 * 60 * 1000

let parsedDataCache: { raw: string; data: any } | null = null

export function getStatsigData(): any | null {
  if (typeof localStorage === 'undefined' || !localStorage) {
    return null
  }

  const raw = localStorage.getItem(DB_KEY)

  if (!raw) {
    parsedDataCache = null

    return null
  }

  if (parsedDataCache && parsedDataCache.raw === raw) {
    return parsedDataCache.data
  }

  try {
    const { data } = JSON.parse(raw)

    parsedDataCache = { raw, data }

    return data
  } catch {
    return null
  }
}

export function setStatsigDataWithTTL(data: any) {
  const now = Date.now()
  const payload = {
    data,
    expiry: now + DB_CACHE_TTL_MS,
  }

  localStorage.setItem(DB_KEY, JSON.stringify(payload))
}

export function getStatsigDataWithTTL(): any | null {
  const raw = localStorage?.getItem(DB_KEY)

  if (!raw) {
    return null
  }

  try {
    const { data, expiry } = JSON.parse(raw)

    if (Date.now() > expiry) {
      localStorage.removeItem(DB_KEY)

      return null
    }

    return data
  } catch {
    return null
  }
}
